export default __webpack_public_path__ + "static/media/Front-Tabliyet-Massaad.fd1df850.jpg";